import React, { useContext, useEffect, useRef, useState } from "react";
import { FileUploaderButton } from "../Components/FileUploaderButton";
import { ReactComponent as Close } from "../assets/icons/x.svg";
import { ReactComponent as ImageIcon } from "../assets/icons/Image.svg";
import { ReactComponent as EditIcon } from "../assets/icons/editImage.svg";
import NewButton from "./NewButton";
import { v4 as uuidv4 } from 'uuid';

import "./UploadImgPopUp.css";
import { NotificationContext } from "../Context/NotificationContext";
import { auth, firestore, storage } from "../firebase.config";

const UploadImgPopUp = ({ windowSize, setShowPopUp, profileEdit, setProfileEdit }) => {
  const [files, setFiles] = useState();
  const { showNotification } = useContext(NotificationContext);

  const [uploadBtn, setUploadBtn] = useState("Upload Picture");

  const [hideUploadBox, setHideUploadBox] = useState(false);
  const [showError, setShowError] = useState(false);

  const [positionX, setPositionX] = useState(0);
  const [positionY, setPositionY] = useState(0);

  const [range, setRange] = useState(10);
  const [drag, setDrag] = useState(false);

  const startX = useRef();
  const startY = useRef();

  const imgRef = useRef();

  const startProfileEdit = (e, touch = false) => {
    startX.current = touch ? e.touches[0].clientX : e.clientX;
    startY.current = touch ? e.touches[0].clientY : e.clientY;
    setDrag(true);
  }
  const endProfileEdit = (e) => {
    setDrag(false);
  }

  const handleMouseMove = (e, touch = false) => {
    if (!drag || uploadBtn !== "Upload Picture") {
      return;
    }

    setPositionX((touch ? e.touches[0].clientX : e.clientX) - (startX.current));
    setPositionY((touch ? e.touches[0].clientY : e.clientY) - (startY.current));
  }

  const handleFiles = (e) => {
    setHideUploadBox(true);
    const mFile = e.target.files[0];

    const fileID = uuidv4();
    setFiles({ id: fileID, name: mFile.name, file: mFile, progress: 0, status: 'uploading' });

    const storageRef = storage.ref();
    const userId = auth.currentUser.uid;

    const fileRef = storageRef.child(userId + '/profile/' + mFile.name);

    const downloadToken = uuidv4();

    const fileName = mFile.name.replace('#', '%23').replace('+', "%2b");

    const url = `${process.env.REACT_APP_STORAGE_URL}/o/${userId}%2Fprofile%2F${fileName}?alt=media&token=${downloadToken}`;

    var metadata = {
      firebaseStorageDownloadTokens: downloadToken,
      customMetadata: {
        'userID': userId
      }
    }

    const uploadTask = fileRef.put(mFile, metadata);

    setFiles(file => file.name === mFile.name && file.ref === mFile.ref ? { ...file, task: uploadTask } : file);

    uploadTask.on('state_changed', (snapshot) => {
      const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
      setFiles(file => file.name === mFile.name && file.ref === mFile.ref ? { ...file, progress: progress.toFixed(2) } : file);
    }, (error) => {
      // setFiles(file => file.name === mFile.name && file.ref === mFile.ref ? { ...file, status: 'failed' } : file);
      setFiles(f => f.filter(file => file.name !== mFile.name && file.ref !== mFile.ref));

      setHideUploadBox(false)
      showNotification("Error uploading.", "There was an error uploading the file " + mFile.name + ". Please, try again.", "error");
    }, () => {
      const imageElement = new Image();
      imageElement.src = url;

      imageElement.addEventListener("load", (e) => {
        // const {naturalWidth, naturalHeight} = e.currentTarget;

        // if(naturalWidth < 100 && naturalHeight < 100){
        //     showNotification("Error uploading.", "Minimum Image size should be 100x100.", "error");
        //     setShowError(true);
        //     setHideUploadBox(false);
        //     setFiles(null);
        // }else{
        //     setShowError(false);
        // }
        setFiles(file => file.name === mFile.name && file.ref === mFile.ref ? { ...file, status: 'complete', ref: userId + '/profile/' + mFile.name, url: url, timestamp: new Date() } : file);
      })

    });
  }

  const handleDeleteFile = file => {
    const checkFile = (file1, file2) => {
      if(file1.id && file2.id){
        return file1.id === file2.id;
      }
      if(file1.ref && file2.ref){
        return file1.ref === file2.ref;
      }
    }
    const storageRef = storage.ref();

    if (file.ref && (file.status === "complete" || file.timestamp)) {
      const fileRef = storageRef.child(file.ref);
      setFiles(mFile => mFile.name === file.name && checkFile(mFile, file) ? { ...mFile, status: 'deleting' } : mFile);

      fileRef.delete()
        .then(function () {
          setFiles(mFile => !checkFile(mFile, file));
          setHideUploadBox(false);
          setRange(10);
        })
        .then(() => {
        })
        .catch(function (error) {
          console.log(error)
          showNotification("Error deleting the file.", "There was an error deleting the file " + file.name + ". Please, try again.", "error");
        });
    } else if (file.status === 'failed') {
      setFiles(mFile => !checkFile(mFile, file));

    } else {
      file.task.cancel();
      setFiles(mFile => !checkFile(mFile, file));
    }
  }

  

  const handleClose = () => {
    if (profileEdit) {
      return setShowPopUp(false);
    }
    setShowPopUp(false);
    setFiles(null);
    setShowError(false);
    setHideUploadBox(false);
    setRange(10);
    setPositionX(0);
    setPositionY(0);
  };

  useEffect(() => {
    const slider = document.querySelector("#slider");
    if (slider) {
      slider.style.background = `linear-gradient(90deg, #12abbf ${(range / 10 - 1) * 100}%, #e6e7e9 0%)`;
    }
  }, [range])

  const handlePicUpload = () => {
    setUploadBtn("Uploading...")

    const leftPosition = `${(positionX * 100) / 200}%`;

    const topPosition = `${(positionY * 100) / 200}%`

    const data = {
      name: files.name, ref: files.ref, url: files.url, type: 'source', size: files.file ? files.file.size : files.size, format: files.file ? files.file.type : files.format, status: 'complete', progress: 100, timestamp: files.timestamp,
      scale: range / 10, left: leftPosition, top: topPosition
    };

    firestore.collection("users").doc(auth.currentUser.uid).update({
      profilePic: data
    }).then(() => {
      handleClose();
    }).catch(e => {
      showNotification("Error deleting the file.", "There was an error updating the file. Please, try again.", "error");
    }).finally(() => {
      setUploadBtn("Upload Picture");
    })
  }


  const handleUploadNewPic = () => {
    setProfileEdit(false);
  }
  
  const handleDeletePic = () => {

    firestore.collection("users").doc(auth.currentUser.uid).update({
      profilePic: null
    }).then(() => {
      setShowPopUp(false);
      setProfileEdit(false);
      setFiles(null);
    }).catch(e => {
      showNotification("Error deleting the file.", "There was an error deleting the file. Please, try again.", "error");
    })
  }

  const imgStyle = { transform: `scale(${range / 10})`, top: positionY, left: positionX };

  if (profileEdit) {
    return <div className="newPopUpModalWrap">
      <div className="newPopUpModalContainer">
        <h2 className="newPopUpModalTitle">Edit Profile Picture</h2>
        <div className="newPopUpModalIcon" style={{ background: "#E6FAF2" }}>
          <EditIcon />
        </div>
        <div className="EditProfilePopUpBtnWrap">
          <NewButton text={"Upload New Picture"} width="100%" onClick={handleUploadNewPic} />
          <NewButton text={"Delete Profile Picture"} width="100%" onClick={handleDeletePic} back whiteBtn icon={false} />
        </div>
        <Close className="newPopUpModalCloseIcon" onClick={handleClose} />
      </div>
    </div>

  }

  return (
    <div className="newPopUpModalWrap">
      <div className="newPopUpModalContainer">
        <div className="newPopUpModalTitle">Upload Picture</div>
        {files && files.status === "complete" && <div className="popUpImgPreviewWrap" id="imageOverlay"
          onMouseDown={(e) => startProfileEdit(e)} onMouseMove={(e) => handleMouseMove(e)} onMouseUp={(e) => endProfileEdit(e)} onMouseLeave={(e) => endProfileEdit(e)} onSelect={(e) => { e.preventDefault() }}
          onTouchStart={(e) => startProfileEdit(e, true)} onTouchMove={(e) => handleMouseMove(e, false)} onTouchEnd={(e) => endProfileEdit(e)} touchcancel={(e) => endProfileEdit(e)}>
          <div className="popUpImgPreviewOverlay"></div>
          <img className="popUpPrevImg" src={files && files.url} id="image" width={"200px"} style={imgStyle} alt="" ref={imgRef} />
          {/* <div className="popUpPreviewImg" id="image" style={{backgroundImage:`url("${url}")`}}></div> */}
        </div>}
        {files && files.status === "complete" &&
          <div className="popUpFileSliderWrap">
            <ImageIcon className="popUpSiiderImg small" />
            <input id="slider" className="popUpFileSlider" type="range" min={10} max={20} value={range} onChange={(e) => setRange(e.target.value)} disabled={uploadBtn === "Uploading..."} />
            <ImageIcon className="popUpSiiderImg" />
          </div>}
        <FileUploaderButton handleDeleteFile={handleDeleteFile} handleFiles={handleFiles} textMaxWidth={files && files.status === "complete" ? "270px" : "150px"}
          files={files ? [files] : []} display={!showError} type="image/png, image/jpeg" hideUploadBox={hideUploadBox} hideAddComment multiple={false} hideDate={true} />
        {showError && <p className="popUpFileError">Minimum Image size should be 100x100</p>}
        <NewButton text={uploadBtn} disabled={!files || files.status !== "complete" || uploadBtn === "Uploading..."} width="100%" onClick={handlePicUpload} />
        <NewButton whiteBtn back={true} icon={false} text="Cancel" width="100%" onClick={handleClose} />
        <Close className="newPopUpModalCloseIcon" onClick={handleClose} />
      </div>
    </div>
  );
};

export default UploadImgPopUp;
